module.exports = __webpack_public_path__ + "img/Folded_Paper_Icon_digital_first_branding.3551d19d.svg";